<script>
  const GAME_HOST = 'https://www.ucmsgroup.ru/game/';
  const TITLE = 'Карты, Деньги, Аутсорс';
  const IMAGE = `${GAME_HOST}/img/ucms_sharing.png`;
  
  const shareVK = () => {
    const vk_url = `https://vk.com/share.php?url=${GAME_HOST}&title=${TITLE}&image=${IMAGE}&noparse=true`;
    window.open(vk_url,TITLE,'width=600,height=400');
  }

  const shareFb = () => {
    const fb_url = `https://www.facebook.com/sharer.php?u=${GAME_HOST}&t=${TITLE}`;
    window.open(fb_url,TITLE,'width=600,height=400');
  }
</script>

<div class="soc-wrapper">
    <img src="./img/icon_facebook.png" alt="fb_icon" on:click={shareFb} />
    <img src="./img/icon_vk.png" alt="vk_icon" on:click={shareVK} />
</div>